import React from 'react';
import { TextField } from '@mui/material';
import { func, string } from 'prop-types';
import { useIntl } from 'react-intl';
import useStyles from './Input.styles';
import { AUTO_COMPLETE } from '../../../../constants/constants';

const UsernameField = ({
  username,
  handleChange,
  handleBlur,
  errorMessageId,
}) => {
  const { classes } = useStyles();
  const { formatMessage } = useIntl();
  const errorMessage = errorMessageId
    ? formatMessage({ id: errorMessageId })
    : '';

  return (
    <TextField
      value={username}
      error={Boolean(errorMessageId)}
      helperText={errorMessage}
      onChange={handleChange}
      onBlur={handleBlur}
      inputProps={{ className: classes.input }}
      label={formatMessage({ id: 'earlyAccess.createUser.label.username' })}
      id="username"
      name="username"
      required
      autoComplete={AUTO_COMPLETE.USERNAME}
    />
  );
};

UsernameField.propTypes = {
  username: string.isRequired,
  handleChange: func.isRequired,
  handleBlur: func.isRequired,
  errorMessageId: string,
};

export default UsernameField;
